<template>
  <nav>
    <v-app-bar app color="primary"  @click="drawer = !drawer">
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text">
        <span class="font-weight-light">NixieClock.Biz</span>
        <span>Admin</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- dropdown menu -->
      <v-menu open-on-hover offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="grey">
            <v-icon left>expand_more</v-icon>
            <span>Menu</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="link in links"
            :key="link.text"
            router
            :to="link.route"
          >
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn color="grey" @click="logout">
        <span>Sign Out</span>
        <v-icon right>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>

    <UsernameDialog
      :show="showUsernameDialog"
      :username="storeState.username"
    />

    <v-navigation-drawer app v-model="drawer" class="primary">
      <v-layout column align-center>
        <v-flex class="mt-5">
          <v-avatar size="100">
            <img class="text-lg-center" src="/avatar-1.png" />
          </v-avatar>
          <p class="white--text subheading mt-1">NixieClock.Biz</p>
        </v-flex>
        <v-flex class="mt-4 mb-3">
          <CreateNewCart />
        </v-flex>
      </v-layout>
      <v-list>
        <v-list-item
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              link.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import CreateNewCart from "./CreateNewCart";
import UsernameDialog from "./UserNameDialog";
import { store } from "../store.js";

export default {
  components: { CreateNewCart, UsernameDialog },
  data() {
    return {
      drawer: false,
      links: [
        { icon: "dashboard", text: "Dashboard", route: "/" },
        { icon: "gavel", text: "Confirm Orders", route: "/order-confirm" },
        { icon: "send", text: "Dispatch Orders", route: "/order-dispatch" },
        { icon: "search", text: "Search Orders", route: "/order-search" },
        { icon: "speaker_notes", text: "Site Messages", route: "/messages" },
        { icon: "dvr", text: "Create Ebay Order", route: "/order-ebay" },
        { icon: "edit", text: "Cart Editor", route: "/cart-edit" },
        { icon: "edit", text: "Item Editor", route: "/item-edit" },
        { icon: "edit", text: "Ebay Item Editor", route: "/ebay-edit" },
        { icon: "edit", text: "Postal Rate Editor", route: "/postal-rate-edit" }
      ],
      storeState: store.state
    };
  },
  computed: {
    showUsernameDialog() {
      return store.getToken() == "";
    }
  },
  methods: {
    logout() {
      store.resetLoginInfo();
      window.location.reload();
    },
  }
};
</script>

<style></style>
